import { useState, useEffect } from 'react';
import { AclConfig, userAcl } from 'api/AccessControlListMiddleware';
import { AdgangAccessControl } from 'api/adgang';

export function useAccessControlList(): [
  AdgangAccessControl[] | undefined,
  (access: AdgangAccessControl) => boolean
] {
  const [aclConfig, setAclConfig] = useState<AclConfig | undefined>(userAcl.config);
  const [acl, setAcl] = useState<AdgangAccessControl[] | undefined>(userAcl.config?.acl);
  const hasAccess = (access: AdgangAccessControl): boolean => acl?.some((x) => x === access) ?? false;

  useEffect(() => {
    const action = () => {
      if (aclConfig?.jwtTokenSignature !== userAcl.config?.jwtTokenSignature) {
        setAclConfig(userAcl.config);
        setAcl(userAcl.config?.acl ?? []);
      }
    };
    action();
    const interval = setInterval(action, 1000);
    return () => clearInterval(interval);
  }, [aclConfig]);

  return [acl, hasAccess];
}
